export default "__VITE_ASSET__7ad91244__"